import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import * as fromDisputeRequest from "../dispute/DisputeRequest";
import { map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { environment } from "../../environments/environment";


export interface IProduct {
    name: String;
    code: String;
};

export interface IUser {
    name: String;
    id: String;
};

@Injectable({
    providedIn: "root"
})
export class ServiceProviderService {

    constructor(private http: HttpClient) {
    }

    createDispute(disputePayload: fromDisputeRequest.DisputeRequest) {
        let logTraceJSON: any = { 'eventSource': 'createDispute', 'payload': disputePayload, 'ban': disputePayload.BusinessPartner, 'contractAccount': disputePayload.ContractAccount, 'invoiceNumber': disputePayload.InvoiceNumber };
        const headers = new HttpHeaders({
            'X-Log-Trace': JSON.stringify(logTraceJSON),
        });
        return this.http.post(environment.serverURL + environment.brimURI + "dispute", disputePayload, { headers });
    }

    getDisputeConfig() {
        let logTraceJSON: any = { 'eventSource': 'getDisputeConfig' };
        const headers = new HttpHeaders({
            'X-Log-Trace': JSON.stringify(logTraceJSON),
        });
        return this.http.get(environment.serverURL + environment.brimURI + "disputeConfig", { headers })
            .pipe(
                map(response => {
                    return response;
                }),
                catchError(() => {
                    return of("Error!!");
                })
            );
    }
}
